<template>
  <CancelHour></CancelHour>
</template>

<script>
// @ is an alias to /src
import CancelHour from "@/components/CancelHour.vue";
export default {
  name: "CancelHourView",
  components: { CancelHour }
};
</script>
